'use client'

import { memo } from 'react'
import { IconCheck } from '@tabler/icons-react'
import clsx from 'clsx'

import Button from 'shared/ui/Button'
import { cssColors } from 'shared/ui/utils/cssTokens'

import { DiscountCode } from '../../types'

import { CardActiveState, CardMode } from './utils'

import styles from '../../../../components/BenefitCodeCard/BenefitCodeActionButton.module.scss'

interface DiscountCodeActionButtonProps {
  cardMode: CardMode
  cardActiveState: CardActiveState
  marketingNotConsent?: boolean
  minimumOrderValueNotAchieved?: boolean
  rebate: DiscountCode
  onClick?: () => void
}

const DiscountCodeActionButton = memo(
  ({
    cardMode,
    cardActiveState,
    marketingNotConsent,
    minimumOrderValueNotAchieved,
    rebate,
    onClick
  }: DiscountCodeActionButtonProps) => {
    if (cardMode === CardMode.used || !onClick) return null

    const buttonClassName = clsx(styles.actionButton, {
      [styles.inactive]: cardActiveState !== CardActiveState.none
    })

    if (cardMode === CardMode.available) {
      if (cardActiveState === CardActiveState.active) {
        return (
          <Button
            variant='neutralOutline'
            className={buttonClassName}
            endIcon={
              <IconCheck size={16} color={cssColors.brand.secondary} />
            }
          >
            Kupon aktywny
          </Button>
        )
      }

      return (
        <Button
          onClick={onClick}
          variant='primary'
          className={buttonClassName}
          aria-label='Aktywuj kupon'
        >
          Aktywuj kupon
        </Button>
      )
    }

    if (cardMode === CardMode.unavailable) {
      if (marketingNotConsent) {
        return (
          <Button
            onClick={onClick}
            variant='primaryOutline'
            className={buttonClassName}
          >
            Zaznacz zgodę i&nbsp;aktywuj kupon
          </Button>
        )
      }

      if (rebate.minimumOrderValue && minimumOrderValueNotAchieved) {
        return (
          <Button
            onClick={onClick}
            variant='primaryOutline'
            className={buttonClassName}
          >
            Zwiększ koszyk i&nbsp;aktywuj kupon
          </Button>
        )
      }
    }

    return null
  }
)

export default DiscountCodeActionButton
